
















import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ResultImage extends Vue {
  hover = false;
  failedImages: string[] = [];

  @Prop({ required: true })
  item: Result;

  @Prop({ default: false })
  flipImageOnHover: boolean;

  get hoverEvents() {
    return this.flipImageOnHover
      ? {
        mouseenter: this.enableHover,
        mouseleave: this.disableHover
      }
      : {};
  }

  get imageSrc(): string {
    return this.hover && this.images.length > 1
      ? this.images[1]
      : this.images[0];
  }

  get images() {
    return this.item.images.filter(image => !this.failedImages.includes(image));
  }

  enableHover() {
    this.hover = true;
  }

  disableHover() {
    this.hover = false;
  }

  flagImageAsFailed() {
    this.failedImages.push(this.imageSrc);
  }
}
